module.exports = __webpack_public_path__ + "442d53a4da561216b91d015f1049e28b.png";